if (!customElements.get("custom-select")) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();

      this.selectEl = this.querySelector("select");

      this.createCustomSelect();

      this.dropdown = this.querySelector(".js-dropdown");
      this.btnToggleDropdown = this.querySelector(".js-btn-dropdown");
      this.listOptions = this.querySelector(".js-list-options");
      this.isExpanded = false;

      this.selectLabel = this.getAttribute("data-label");

      window.addEventListener("shopify:section:load", () => {
        clearTimeout(this.loadTimeout);
      });

      window.addEventListener("resize", () => {
        const isMobileMedium = window.innerWidth < tabletWidth;

        if (isMobileMedium) {
          return;
        }

        const isWidthUnchanged =
            +this.btnToggleDropdown.style.width.replace("px", "") ===
            this.dropdown.clientWidth;

        if (isWidthUnchanged) {
          return;
        }

        this.btnToggleDropdown.style.width = `${this.dropdown.clientWidth}px`;
      });

      this.btnToggleDropdown.addEventListener("click", e => {
        e.preventDefault();

        const isExpanded = this.classList.contains("is-expanded");

        if (isExpanded) {
          this.hideDropdown();

          return;
        }

        this.showDropdown();
      });

      this.btnToggleDropdown.addEventListener("keydown", e => {
        if (e.key.includes("Arrow")) {
          e.preventDefault();

          const isArrowRight = e.key.includes("Right");
          const isHorizontalArrow =
              e.key.includes("Left") || isArrowRight;

          if (this.isExpanded && isHorizontalArrow) {
            return;
          }

          const isNextKey = isArrowRight || e.key.includes("Down");

          const btnOptionSelected = this.listOptions.querySelector(
              ".js-btn-option.is-selected"
          );
          const selectedOptionParent =
              btnOptionSelected.parentElement;
          let prevNextBtnOption = isNextKey
              ? selectedOptionParent.nextElementSibling
                  ?.firstElementChild
              : selectedOptionParent.previousElementSibling
                  ?.firstElementChild;

          if (!prevNextBtnOption) {
            prevNextBtnOption = isNextKey
                ? this.listOptions.firstElementChild.firstElementChild
                : this.listOptions.lastElementChild.firstElementChild;
          }

          this.changeSelectedOption(
              btnOptionSelected,
              prevNextBtnOption
          );

          return;
        }

        if (!this.isExpanded) {
          return;
        }

        const isEscape = e.key === "Escape";
        const isTab = e.key === "Tab";

        if (!isEscape && !isTab) {
          return;
        }

        e.preventDefault();

        this.hideDropdown();
      });

      this.listOptions.addEventListener("click", e => {
        const isBtnOption =
            e.target.classList.contains("js-btn-option");

        if (!isBtnOption) {
          return;
        }

        e.preventDefault();

        const btnOption = e.target;
        const isSelected =
            btnOption.classList.contains("is-selected");

        // Check if the native select has an empty value (no actual sorting applied)
        const currentNativeValue = this.selectEl.querySelector('option[selected="selected"]').value;
        const isDefaultState = currentNativeValue === '';

        this.hideDropdown();

        // Allow clicking if it's the default state and user clicks "Recommended"
        if (isSelected && !(isDefaultState && btnOption.dataset.value === 'best-selling')) {
          return;
        }

        this.changeSelectedOption(undefined, btnOption);
      });

      // Close button event listener
      this.addEventListener("click", e => {
        const isCloseBtn = e.target.closest(".js-btn-close-select");

        if (!isCloseBtn) {
          return;
        }

        e.preventDefault();
        this.hideDropdown();
      });

      document.addEventListener("click", e => {
        if (!this.isExpanded) {
          return;
        }

        const isThisSelect =
            e.target.closest("custom-select") === this;

        if (isThisSelect) {
          return;
        }

        this.hideDropdown();
      });
    }

    createCustomSelect() {
      const selectLabel = this.getAttribute("data-label");
      const options = this.querySelectorAll("option");
      const selectedOption = this.selectEl.querySelector(
          'option[selected="selected"]'
      );
      let optionsMarkup = "";

      options.forEach(option => {
        // If the selected option has no value and this is the 'best-selling' option, mark it as selected
        const isDefaultRecommended = selectedOption.value === '' && option.value === 'best-selling';
        // Don't mark the empty option as selected in the dropdown if it's selected in the native select
        const isSelected = (option.selected && option.value !== '') || isDefaultRecommended;

        const optionMarkup = `
          <li class="custom-select__item">
            <button
              type="button"
              class="custom-select__option button-reset js-btn-option ${
            isSelected ? "is-selected" : ""
        }"
              data-value="${option.value}"
              tabindex="-1"
              aria-selected="${isSelected}"
            >${option.textContent}</button>
          </li>
        `;

        optionsMarkup += optionMarkup;
      });

      const markup = `
        <div class="custom-select__wrapper">
    
          <button
            type="button"
            class="custom-select__btn button-reset focus-inset js-btn-dropdown facets__button-custom"
            aria-controls="${this.dataset.dropdownId}"
            aria-expanded="false"
          >
            ${selectedOption.textContent} ${this.dataset.iconChevronDown}
          </button>
     
          <div class="custom-select__dropdown js-dropdown" id="${this.dataset.dropdownId}">
              <div class="mobile-header-sorting">
            <h1>${document.documentElement.lang === 'ar' ? 'ترتيب حسب' : 'Sort by'}</h1>
            <button type="button" class="custom-select__close js-btn-close-select" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            </div>
            <ul class="custom-select__items list-unstyled js-list-options">
              ${optionsMarkup}
            </ul>
          </div>
        </div>
      `;

      this.insertAdjacentHTML("afterbegin", markup);
      this.dataset.value = selectedOption.value;
    }

    changeSelectedOption(
        selectedOption = this.listOptions.querySelector(
            ".js-btn-option.is-selected"
        ),
        newSelectedOption
    ) {
      this.btnToggleDropdown.innerHTML = newSelectedOption.textContent + this.dataset.iconChevronDown;
      this.dataset.value = newSelectedOption.dataset.value;

      newSelectedOption.classList.add("is-selected");
      newSelectedOption.setAttribute("aria-selected", true);

      // Only remove the selected class if it's a different option
      if (selectedOption && selectedOption !== newSelectedOption) {
        selectedOption.classList.remove("is-selected");
        selectedOption.setAttribute("aria-selected", false);
      }

      const nativeSelectedOption = this.selectEl.querySelector(
          'option[selected="selected"]'
      );
      const newNativeSelectedOption = this.selectEl.querySelector(
          `option[value="${this.dataset.value}"]`
      );

      nativeSelectedOption.removeAttribute("selected");
      newNativeSelectedOption.setAttribute("selected", "selected");

      // Trigger input event

      const inputEvent = new Event("input", { bubbles: true });

      this.selectEl.dispatchEvent(inputEvent);
    }

    showDropdown() {
      this.isExpanded = true;
      this.classList.add("is-expanded");
      this.btnToggleDropdown.setAttribute("aria-expanded", true);
    }

    hideDropdown() {
      this.isExpanded = false;
      this.classList.remove("is-expanded");
      this.btnToggleDropdown.setAttribute("aria-expanded", false);
    }
  }

  customElements.define("custom-select", CustomSelect);
}
